import { Row, Col } from "react-bootstrap";

const ContactUs = () => {
  const text = (
    <div>
      <p>
        <b>Contact Us</b>
      </p>
      <p>For further queries, please contact </p>
      <p>
        Email: <a href="mailto: licensing@epa.ie">licensing@epa.ie</a>.
      </p>
      <p>Telephone: 053 91 60600.</p>
    </div>
  );

  return (
    <Row>
      <Col className="ps-4">{text}</Col>
    </Row>
  );
};

export default ContactUs;
